<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-15 20:03:24
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:26:28
--> 
<template>
  <div class="textareabox">
    <!-- -->
    <div class="textBox" @click="changeClick">
      <div :id="'editor' + 'qwert'"></div>
      <editor
        :readonly="true"
        :overflow="false"
        :menuShow="true"
        height="100vh"
        name="qwert"
        :errMsg="errMsg"
        :label="label || $t('label_The_mail_text') + '*'"
        :content="defaultcontent.content"
      >
      </editor>
    </div>
    <mrc_ess_myDialog
      v-model="isShow"
      hiddenTitle
      :disabled="false"
      :title="$t('label_New_emergency_contact')"
      width="80vw"
    >
      <v-tabs
        v-model="tab"
        grow
        background-color="#ffffff"
        color="primary"
        dark
      >
        <v-tab
          v-for="item in childrencontent"
          class="text-capitalize"
          :key="item.language_code"
        >
          {{ returnLabel(item.language_code) }}
        </v-tab>
      </v-tabs>
      <!--  :label="item.language_code+'*'" -->
      <v-tabs-items v-model="tab">
        <v-card-text class="pa-0">
          <v-form ref="fieldForm">
            <v-tab-item v-for="(item, index) in childrencontent" :key="index">
              <div :id="'dv' + index"></div>
              <!-- <div :id="'editor'+index"></div> -->

              <editor
                :content="item.content"
                :name="index"
                ref="editor"
                height="100vh"
                @addpro="addpro"
                :errMsg="errMsgArr[index]"
                :readonly="readonly"
                @enterUp="enterUp"
                @changeContent="changeContent($event, item, index)"
                @handleinputBlur="handleinputBlur"
              >
              </editor>
              <propertyDialog
                :readonly="!readonly"
                sysStatus
                class="mt-n1"
                :function_uuid="function_uuid"
                @getsyslist="getsyslist($event, index)"
                @getpropertylist="getpropertylist($event, index)"
              ></propertyDialog>
            </v-tab-item>
            <mrc_ess_submitBtn
              v-if="!readonly"
              @cancel="cancel"
              backgroundColor="#FFFFFF"
              class="submitBtn"
              style="height: auto; justify-content: flex-end"
              @success="success"
            >
            </mrc_ess_submitBtn>
          </v-form>
        </v-card-text>
      </v-tabs-items>
    </mrc_ess_myDialog>
  </div>
</template> 

<script>
import Item from "../../../components/treeList/Item.vue";
import editor from "./editor.vue";
import propertyDialog from "./propertyDialog";
export default {
  components: {
    propertyDialog,
    editor,
    Item,
  },
  props: {
    errMsg: {},
    label: {
      type: String,
    },
    // defaultcontent: {
    //   type: String,
    //   default: '请设置内容'
    // },
    content: {
      //国际化字段
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    function_uuid: {
      type: String,
    },
  },
  model: {
    prop: "content",
    event: "contentChange",
  },
  data() {
    return {
      rules: [(value) => !!value || this.$t("verify_Required")],
      showMenu: false,
      childrencontent: [],
      childrencontentCopy: [],
      blurIndex: "",
      isShow: false,
      errMsgArr: [],
      tab: 0,
    };
  },
  computed: {
    defaultcontent() {
      let obj = {
        language_code: this.$store.state.lang, //国际化代码
        content_type: "2", //国际化字段(1:邮件主题  2:邮件内容)
        content: "",
      };
      this.content.map((item) => {
        if (
          item.language_code.toLowerCase() ==
          this.$store.state.lang.toLowerCase()
        ) {
          obj = {
            language_code: item.language_code, //国际化代码
            content_type: "2", //国际化字段(1:邮件主题  2:邮件内容)
            content: item.content,
          };
        }
      });
      return obj;
    },
  },
  created() {},
  watch: {
    isShow(v) {
      const tooltipdom = document.querySelectorAll(
        "div[class='w-e-tooltip w-e-tooltip-up']"
      );
      if (tooltipdom && tooltipdom.length > 0) {
        tooltipdom.forEach((item) => {
          item.remove();
        });
      }
      if (!v) {
        if (Array.isArray(this.content) && this.content.length <= 0) {
          if (
            this.$store.state.currentCompanyLanguage &&
            !this.$store.state.currentCompanyLanguage.length > 0
          )
            return;
          let arr = [];
          this.$store.state.currentCompanyLanguage.map((item) => {
            arr.push({
              language_code: item.value, //国际化代码
              content_type: "2", //国际化字段(1:邮件主题  2:邮件内容)
              content: "",
            });
          });
          this.childrencontent = this.$clone(arr);
        } else {
          this.childrencontent = this.$clone(this.content);
        }
      } else {
        // console.log(this.$refs.editor);
        this.$refs.editor
          ? this.$refs.editor.forEach((item) => {
              item.cloneContent();
            })
          : "";
        this.$refs.fieldForm ? this.$refs.fieldForm.reset() : "";
      }
    },
    content: {
      handler(v) {
        this.childrencontent = this.$clone(v);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$store.state.uuid) {
      this.childrencontent = this.$clone(this.content);
    } else {
      if (
        this.$store.state.currentCompanyLanguage &&
        !this.$store.state.currentCompanyLanguage.length > 0
      )
        return;
      let arr = [];
      this.$store.state.currentCompanyLanguage.map((item) => {
        arr.push({
          language_code: item.value, //国际化代码
          content_type: "2", //国际化字段(1:邮件主题  2:邮件内容)
          content: "",
        });
      });
      this.childrencontent = this.$clone(arr);
    }
    this.childrencontentCopy = this.$clone(this.childrencontent);
  },
  methods: {
    addpro() {
      // console.log("父组件");
    },
    returnLabel(val) {
      if (
        this.$store.state.currentCompanyLanguage &&
        !this.$store.state.currentCompanyLanguage.length > 0
      )
        return;
      let str = null;
      this.$store.state.currentCompanyLanguage.forEach((item) => {
        if (val.toLowerCase() == item.value.toLowerCase()) {
          str = item.text;
        }
      });
      return str;
    },
    enterUp() {
      //回车事件
    },
    changeContent(v, item, index) {
      this.$set(this.childrencontentCopy[index], "content", v);
      this.verification();
      // console.log(this.childrencontentCopy);
    },
    verification() {
      let arr = [];
      let isno = true;
      // this.childrencontent.forEach(item => {
      //   if (!item.content) {
      //     isno = false
      //     arr.push([this.$t('verify_Required')])
      //   }
      //   else {
      //     arr.push([])
      //   }
      // })
      this.childrencontentCopy.forEach((item) => {
        if (!item.content) {
          isno = false;
          arr.push([this.$t("verify_Required")]);
        } else {
          arr.push([]);
        }
      });
      this.errMsgArr = arr;
      return isno;
    },
    changeClick() {
      this.isShow = true;
    },
    success() {
      this.childrencontent = this.$clone(this.childrencontentCopy);
      if (!this.verification())
        return this.$myConfirm({
          content: this.$t("verify_the_content_is_not_complete"),
        });
      this.isShow = false;
      this.$emit("contentChange", this.childrencontent);
    },
    cancel() {
      this.isShow = false;
      this.childrencontent = this.$clone(this.content);
    },
    getsyslist(v, index) {
      // v.map(item1 => {
      //   this.childrencontent[index].content ? this.childrencontent[index].content = this.childrencontent[index].content.slice(0, this.blurIndex) + item1.property + this.childrencontent[index].content.slice(this.blurIndex) : this.childrencontent[index].content = item1.property
      // })
      // })
      let string = "";
      v.forEach((item) => {
        string += item.property;
      });
      this.$refs.editor[index].insert(string);
    },
    getpropertylist(v, index) {
      // v.map(item1 => {
      //   this.childrencontent[index].content ? this.childrencontent[index].content = this.childrencontent[index].content.slice(0, this.blurIndex) + item1.property + this.childrencontent[index].content.slice(this.blurIndex) : this.childrencontent[index].content = item1.property
      // })
      let string = "";
      v.forEach((item) => {
        string += item.property;
      });
      this.$refs.editor[index].insert(string);
      // this.$set(this.childrencontent, index, item)
    },
    handleinputBlur(val) {
      this.blurIndex = val;
      // this.blurIndex = e.srcElement.selectionStart
      // let dd = e.srcElement.selectionEnd
      // console.log(this.blurIndex);
    },
  },
};
</script>

<style scoped>
.submitBtn /deep/ .cencelBtn {
  margin-right: 0;
}

/* .btnbox /deep/ .btnGroup {
  justify-content: initial;
  flex-direction: row-reverse;
  padding-right: 35px;
} */
.textBox /deep/ textarea {
  text-indent: 8px;
}
</style>
